import { Input, FormControl, FormErrorMessage, Tooltip } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import UserInputConfirmation from './UserInputConfirmation';

function UpdateThresholdConfirmation(props) {
  const isNumeric = (input) => {
    return !isNaN(input) && parseInt(input) > 0;
  };

  const body = 'Please input the new scan threshold that you want!';
  const tooltipMsg = 'This is the maximum number of times that the product can be scanned at an unintended location. A warning email will be sent if this limit is exceeded.';
  const bodyComponent = () => (
    <div>
      <p style={{ marginLeft: '30px' }}>
        {body.split(' ').map((word, index) => {
          if (word === 'threshold') {
            return (
              <Tooltip key={index}label={tooltipMsg}>
                <span style={{ textDecoration: 'underline' }}>{word} </span>
              </Tooltip>
            );
          } else {
            return <span key={index}>{word} </span>;
          }
        })}
      </p>
    </div>
  );
  const { header, isOpen, handleClose, handleUpdate, input, setInput } = props;
  const [isInputInvalid, setInputInvalid] = useState(false);
  const userInput = (
    <FormControl isInvalid={isInputInvalid}>
        <Input value={input} onChange={e => {
          setInput(e.target.value);
          if (isNumeric(e.target.value)) {
            setInputInvalid(false);
          } else {
            setInputInvalid(true);
          }
        }} placeholder='Set the scan threshold value'/>
    {isInputInvalid && <FormErrorMessage>Threshold has to be a positive integer!</FormErrorMessage>}
    </FormControl>
  );

  return (
    <UserInputConfirmation
      body={bodyComponent}
      header={header}
      isOpen={isOpen}
      handleClose={handleClose}
      handleAction={handleUpdate}
      actionButtonText='Update'
      actionButtonBgColor='green.500'
      isDisabled={isInputInvalid}
      userInput={userInput}
    />
  );
}

UpdateThresholdConfirmation.propTypes = {
  header: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
  handleUpdate: PropTypes.func,
  input: PropTypes.number,
  setInput: PropTypes.func
};

export default UpdateThresholdConfirmation;
